// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1JpyQ","paramInput":"JobSimulator_paramInput__bClBo","input":"JobSimulator_input__2iH13"};